import { Component, Input, OnInit } from '@angular/core';
import { texts } from '../activity-item.texts';

@Component({
  standalone: false,
  selector: 'sc-activity-item-project-created',
  templateUrl: './activity-item-project-created.component.html',
  styleUrls: ['./activity-item-project-created.component.scss']
})
export class ActivityItemProjectCreatedComponent implements OnInit {

  @Input()
  activity : any;

  @Input()
  condensed = false;

  @Input()
  showProjectName = false;
  
  @Input()
  language: 'de' | 'en' = 'de';

  texts = texts;

  constructor() { }

  ngOnInit(): void {
  }

}
